// src/actions/employmentActions.js
import api from '../api/axios';
import {
  FETCH_EMPLOYMENT_REQUEST,
  FETCH_EMPLOYMENT_SUCCESS,
  FETCH_EMPLOYMENT_FAILURE,

  CREATE_EMPLOYMENT_REQUEST,
  CREATE_EMPLOYMENT_SUCCESS,
  CREATE_EMPLOYMENT_FAIL,

  DELETE_EMPLOYMENT_REQUEST,
  DELETE_EMPLOYMENT_SUCCESS,
  DELETE_EMPLOYMENT_FAIL,

  UPDATE_EMPLOYMENT_REQUEST,
  UPDATE_EMPLOYMENT_SUCCESS,
  UPDATE_EMPLOYMENT_FAIL,
} from '../constants/employmentConstants';

export const fetchEmployment = () => async (dispatch) => {
  dispatch({ type: FETCH_EMPLOYMENT_REQUEST });

  try {
    const { data } = await api.get('/employment/my-employment/');

    dispatch({
      type: FETCH_EMPLOYMENT_SUCCESS,
      payload: Array.isArray(data) ? data : (data.results || [])
    });

  } catch (error) {
    dispatch({
      type: FETCH_EMPLOYMENT_FAILURE,
      payload: error.response && error.response.data.detail
        ? error.response.data.detail
        : error.message,
    });
  }
};

export const createEmployment = (
  position,
  employer_name,
  city,
  start_date,
  end_date,
  description = []
) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_EMPLOYMENT_REQUEST });

    await api.post('/employment/my-employment/create/', {
      position,
      employer_name,
      city,
      start_date,
      end_date,
      description
    });

    dispatch({ type: CREATE_EMPLOYMENT_SUCCESS });
    dispatch(fetchEmployment());
  } catch (error) {
    dispatch({
      type: CREATE_EMPLOYMENT_FAIL,
      payload:
        error.response?.data?.non_field_errors?.[0] ||
        error.response?.data?.detail ||
        error.message
    });
  }
};

export const deleteEmployment = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_EMPLOYMENT_REQUEST });

    await api.delete(`/employment/my-employment/delete/${id}/`);

    dispatch({ type: DELETE_EMPLOYMENT_SUCCESS });
    dispatch(fetchEmployment());
  } catch (error) {
    dispatch({
      type: DELETE_EMPLOYMENT_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};

export const updateEmployment = (employment) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_EMPLOYMENT_REQUEST });

    const { data } = await api.put(
      `/employment/my-employment/update/${employment.id}/`,
      employment
    );

    dispatch({
      type: UPDATE_EMPLOYMENT_SUCCESS,
      payload: data
    });

    dispatch(fetchEmployment());
  } catch (error) {
    dispatch({
      type: UPDATE_EMPLOYMENT_FAIL,
      payload: error.response?.data?.detail || error.message
    });
  }
};